<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-form :inline="true">
            <el-form-item>
              <el-input size="mini" placeholder="请输入客户名称/项目名称" v-model="keyword" clearable style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                size="mini" v-model="month_value" type="monthrange"
                format="yyyy-MM" value-format="yyyy-MM"
                start-placeholder="开始月份" end-placeholder="结束月份">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="entry_type_name" placeholder="业务类型" clearable>
                <el-option
                  v-for="item in business_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="exportExcel">导出报表</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="table-wrap">
          <el-table :data="pageData.list" v-loading="loading" border stripe style="width: 100%" height="600px">
            <el-table-column label="年月" prop="month"></el-table-column>
            <el-table-column label="合同区域" prop="contract_area" width="180"></el-table-column>
            <el-table-column label="负责人" prop="project_leader"></el-table-column>
            <el-table-column label="客户简称" prop="party_a_abbreviation"></el-table-column>
            <el-table-column label="用友系统项目名称" prop="project_name" width="180"></el-table-column>
            <el-table-column label="项目编码" prop="project_number"></el-table-column>
            <el-table-column label="业务类型" prop="contract_entry_name"></el-table-column>
            <el-table-column label="月合同金额" prop="contract_amount"></el-table-column>
            <el-table-column label="含税收入" prop="tax_income"></el-table-column>
            <el-table-column label="不含税收入">
              <el-table-column label="不含税收入" prop="no_tax_income"></el-table-column>
              <el-table-column label="其他收入" prop="no_tax_other_income"></el-table-column>
              <el-table-column label="小计" prop="no_tax_total"></el-table-column>
            </el-table-column>
            <el-table-column label="月度主营业务成本">
              <el-table-column label="工资及福利" prop="salary"></el-table-column>
              <el-table-column label="临时工" prop="temporary_work"></el-table-column>
              <el-table-column label="劳务费" prop="labor_fee"></el-table-column>
              <el-table-column label="外包费" prop="outsourcing_fee"></el-table-column>
              <el-table-column label="物料" prop="materials"></el-table-column>
              <el-table-column label="社保及福利费" prop="social_fee"></el-table-column>
              <el-table-column label="租赁费" prop="hiring_fee"></el-table-column>
              <el-table-column label="维修费" prop="repair_fee"></el-table-column>
              <el-table-column label="折旧费" prop="depreciation_fee"></el-table-column>
              <el-table-column label="其他费用" prop="other_cost_fee"></el-table-column>
              <el-table-column label="小计" prop="main_business_cost"></el-table-column>
            </el-table-column>
            <el-table-column label="管理费2.5%" prop="management_fee"></el-table-column>
            <el-table-column label="营业税金及附加值比例" prop="business_tax_rate"></el-table-column>
            <el-table-column label="营业税金及附加" prop="business_tax"></el-table-column>
            <el-table-column label="劳务服务费" prop="work_server"></el-table-column>
            <el-table-column label="残保人保障金" prop="disabled_person_fee"></el-table-column>
            <el-table-column label="雇主责任险" prop="work_insure_fee"></el-table-column>
            <el-table-column label="税后净利润" prop="business_tax_profit"></el-table-column>
            <el-table-column label="净利润率" prop="business_tax_profit_rate"></el-table-column>
            <el-table-column label="本月实际">
              <el-table-column label="主营收入" prop="actual_income"></el-table-column>
              <el-table-column label="人力成本" prop="actual_worker"></el-table-column>
              <el-table-column label="物料" prop="actual_material"></el-table-column>
              <el-table-column label="外包费" prop="actual_outsourcing"></el-table-column>
              <el-table-column label="其他费用" prop="actual_other"></el-table-column>
              <el-table-column label="净利润" prop="actual_profit"></el-table-column>
              <el-table-column label="净利润率" prop="actual_profit_rate"></el-table-column>
            </el-table-column>
            <el-table-column label="本月预算">
              <el-table-column label="主营收入" prop="plan_income"></el-table-column>
              <el-table-column label="人力成本" prop="plan_worker"></el-table-column>
              <el-table-column label="物料" prop="plan_material"></el-table-column>
              <el-table-column label="外包费" prop="plan_outsourcing"></el-table-column>
              <el-table-column label="其他费用" prop="plan_other"></el-table-column>
              <el-table-column label="净利润" prop="plan_profit"></el-table-column>
              <el-table-column label="净利润率" prop="plan_profit_rate"></el-table-column>
            </el-table-column>
            <el-table-column label="本月差异">
              <el-table-column label="主营收入" prop="diff_income"></el-table-column>
              <el-table-column label="人力成本" prop="diff_worker"></el-table-column>
              <el-table-column label="物料" prop="diff_material"></el-table-column>
              <el-table-column label="外包费" prop="diff_outsourcing"></el-table-column>
              <el-table-column label="其他费用" prop="diff_other"></el-table-column>
              <el-table-column label="净利润" prop="diff_profit"></el-table-column>
              <el-table-column label="净利润率" prop="diff_profit_rate"></el-table-column>
            </el-table-column>
            <el-table-column label="亏损原因" prop="reason"></el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total" :page-size="pageData.pageSize" :current-page="pageData.page" @current-change="pageChange"></el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";
import Api from "./common/Api";
import {Message} from "element-ui";

export default {
  name:"ArrearageAging",
  components: {AreaTree, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      upload_url : '',
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:10,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        month:"",
        contract_id:"",
        month_key:"",
        amount:"",
        invoice_amount:"",
        paid_amount:"",
        status:"",
        is_end:"",
        is_invoice:"",
        is_paid:"",
        files:"",
        remarks:"",
      },
      month_value:"",
      business_list:[],
      entry_type_name:"",
      multipleSelection:[],
      f_status:"",
      month_keys:{},
      where_time:"",
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.upload_url = Api.getUploadUrl('/contract/RightReport/uploadData')
    // 当前月
    this.month_value = [
      CommonHelp.date("YYYY-MM"),
      CommonHelp.date("YYYY-MM")
    ];
    this.where_time=['2019-01',CommonHelp.date("YYYY-MM")]
    // this.getList()
    this.getBusinessList()
  },
  activated() {
    this.getList()
  },
  watch: {

  },
  computed:{
    month_list(){
      var that=this;
      let list=Object.keys(that.month_keys);
      list.sort();
      return list;
    }
  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      // this.month_value&&(where.month=this.month_value);
      // where['f.status']=this.f_status;
      CommonHelp.get("RightReport/getDataList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize,
        start_month : this.month_value[0] ,
        end_month : this.month_value[1]
      },res=>{
        if(res.code) {
          that.pageData.list=res.data.list;
          that.pageData.total=res.data.total;
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);

      CommonHelp.get("RightReport/downloadData",{
        where:JSON.stringify(where),
        start_month : this.month_value[0] ,
        end_month : this.month_value[1],
        download_type : 'group',
      },res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    // 日志列表
    getLogList(){
      let that = this;
      CommonHelp.get("RightReport/logList",{
        id :this.log_id ,
        page : this.log_page ,
        page_size : this.log_page_size
      },res=>{
        if(res.code) {
          that.log_list = res.data.list;
          that.log_total = res.data.total;
        }
      })
    },
    // 操作日志分页
    handleLogPageChange(page){
      this.log_page = page;
      this.getLogList();
    },

    // 修改数据
    editRightReport(row){
      this.update_visible = true;
      this.update_form = row;
    },
    sendUpdate(){
      CommonHelp.post("RightReport/update",this.update_form,res=>{
        if(res.code) {
          this.update_visible = false;
          this.getList();
          Message.success(res.msg)
        }
      })
    },

  }
}
</script>

<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/RightReportTable.vue